import { ToastContainer } from 'react-toastify';
import { Provider } from 'react-redux';
import { hotjar } from 'react-hotjar';
import TagManager from 'react-gtm-module';
import ReactGA from 'react-ga4';
import { AppStore } from 'app/App.store';
import { AppRouter } from 'app/App.router';
import { FlagProvider } from '@ui-core/utils/featureflag/flagContext';
import { BrowserRouter } from '@router';
import { env } from '@config';
import '@web-font';
import './CustomToastify.scss';
import 'app/styles/app.scss';
import 'react-toastify/dist/ReactToastify.min.css';
import './App.scss';

const tagManagerArgs = {
	gtmId: 'GTM-PVW8VDC',
	dataLayerName: 'PageDataLayer',
};
TagManager.initialize(tagManagerArgs);
ReactGA.initialize('G-BRM36DZPWM');
hotjar.initialize(
	Number(import.meta.env.REACT_APP_HJID),
	Number(import.meta.env.REACT_APP_HJSV),
);

/**
 * App container.
 *
 * Here occur the initialization,
 * for routing, store and main app.
 *
 * @returns App container
 */
export const App: React.FC = (): JSX.Element => {
	return (
		<BrowserRouter basename={env.APP.BASE_PATH}>
			<Provider store={AppStore}>
				<FlagProvider>
					<AppRouter />
				</FlagProvider>
				<ToastContainer />
			</Provider>
		</BrowserRouter>
	);
};
